import Coach from '../models/Coach';
import Data from './Data';

class Coaches extends Data {
    constructor() {
        super(Coach);
    }
}

export default new Coaches();
